export default "__VITE_ASSET__DuQ8h_46__"